import heroSection from './heroSection.json';
import compensationSection from './compensationSection.json';
import benefitsSection from './benefitsSection.json';
import commonSection from './commonSection.json';
import helpSection from './helpSection.json';
import brandsCrouselSection from './brandsCrouselSection.json';
import newsSection from './newsSection.json';
import ctaSection from './ctaSection.json';
import faqSection from './faqSection.json';

export default {
  heroSection,
  compensationSection,
  benefitsSection,
  commonSection,
  helpSection,
  brandsCrouselSection,
  newsSection,
  ctaSection,
  faqSection,
};
